import React, {useEffect} from 'react';
import { Routes,} from 'react-router-dom';
import {getNotAuthRoutes} from '@Components/BaseNotRoute';
import {getAuthRoutes} from '@Components/BaseRoute';
import Main from '@Components/frame/Main';
import ServerErrorPopup from '@Components/ServerErrorPopup';
import NotificationComponent from '@Components/Notification/NotificationComponent';
import {useAuth} from '@Services/AuthService/useAuth';
import SuspenseLoader from '@Components/customComponents/SuspenseLoader';

const App = () => {
	const { isAuthorized, loadData, initSession, permissions } = useAuth();

	useEffect(() => {
		initSession();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (loadData) {
		return <SuspenseLoader />; 
	}
	
	return isAuthorized()
		? (
			<>
				<NotificationComponent />
				<ServerErrorPopup />
				<Main
					routesAuth={<Routes>{getAuthRoutes(permissions)}</Routes>}
					permissions={permissions}
				/>
			</>
		)
		: <Routes>{getNotAuthRoutes}</Routes>;
};

export default App;
